<template>

    <v-card class="card-integration mt-2 mb-6" width='90%' raised max-width='360px'>
 
        <v-btn absolute fab small right icon @click="openHelpLink">
            <v-icon color='#4ec5c1'>mdi-help-circle-outline</v-icon>
        </v-btn>

        <v-btn class="mr-9" absolute fab small right icon @click="dialogOptions = true">
            <v-icon color="#4ec5c1">mdi-cog-sync-outline</v-icon>
        </v-btn>

        <v-img height='180' class="pointer" @click='openIntegratorLink' :src='img' alt='Integrator img'></v-img>

        <v-card-text>

            <v-row no-gutters>

                <v-col cols='2' class="d-flex align-center">

                    <v-tooltip top open-on-hover>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn @click="syncClick" v-bind="attrs" v-on="on" icon>
                                <v-icon color='#4ec5c1'>mdi-sync</v-icon>
                            </v-btn>
                        </template>
                        <span>{{ $t('integrations.sync_now') }}</span>
                    </v-tooltip>

                </v-col>

                <v-col class="d-flex align-center">

                    <div> {{ $t('integrations.updated_at') }}: {{ integration.last_sync | dateTransform }}</div>

                </v-col>

            </v-row>

            <v-row>

                <v-col cols='2' class="d-flex align-center">

                    <v-btn icon class="no-click">
                        <v-icon color='#4ec5c1'>mdi-link</v-icon>
                    </v-btn>

                </v-col>

                <v-col class="d-flex align-center">

                    <v-tooltip top open-on-hover>
                        <template v-slot:activator="{ on, attrs }">
                            <div class="text-truncate url-field" v-bind="attrs" v-on="on" solo>
                                {{integration.url}}
                            </div>
                        </template>
                        <span class="url-field-2"> {{integration.url}}</span>
                    </v-tooltip>

                </v-col>           

            </v-row>

            <v-row>

                <v-col cols='2' class="d-flex align-center">

                    <v-btn icon class="no-click">
                        <v-icon color='#4ec5c1'>mdi-menu-right</v-icon>
                    </v-btn>

                </v-col>

                <v-col class="d-flex align-center">

                    <v-tooltip top open-on-hover>
                        <template v-slot:activator="{ on, attrs }">
                            <div class="text-truncate url-field name-field" v-bind="attrs" v-on="on" solo>
                                {{integration.name}}
                            </div>
                        </template>
                        <span class="name-field-2"> {{integration.name}}</span>
                    </v-tooltip>

                </v-col>

            </v-row>

            <v-divider class="mt-4 mb-4"></v-divider>

            <v-row>

                <v-col class="d-flex justify-center align-center">

                    <div v-if="!integration.error_msg" class="primary--text body-2"> {{ $t('integrations.auto_sync') }}</div>
                    <div v-else class="red--text body-2"> {{ integration.error_msg }}</div>

                </v-col>

            </v-row>

        </v-card-text>

        <v-dialog width="500" v-if="dialogOptions" v-model="dialogOptions" :fullscreen='isMobile ? true : false' transition="dialog-bottom-transition">

            <v-toolbar dark color="primary">

                <v-btn icon dark @click="dialogOptions = false">
                    <v-icon>mdi-close</v-icon>
                </v-btn>

                <v-toolbar-title> {{$t('integration')}}</v-toolbar-title>

                <v-spacer></v-spacer>

            </v-toolbar>

            <v-card class='d-flex overflow-hidden'>

                <ozmap-options v-if="dialogOptions" :integrations="integration" @changedIntegration='handleChangedOptions' />

            </v-card>

        </v-dialog>

    </v-card>

</template>

<script>

import dayjs from 'dayjs';
import { mapActions } from 'vuex';
import { GET_INTEGRATIONS, SYNC_INTEGRATION } from '../../../store/mutations';
import OzmapOptions from './OzmapOptions.vue';

export default {
  components: { OzmapOptions },

    name: 'IntegrationsCard',

    props: ['integration'],

    filters: {

        dateTransform(date) {

            return dayjs(date).format('DD/MM/YYYY - HH:mm:ss')

        },

    },

    data() {
        return {
            
            img: '',
            integrationLink: '',
            link: '',
            dialogOptions: false

        }
    },

    computed: {

        

    },

    methods: {

        ...mapActions({ syncIntegration: `ProviderVuex/${SYNC_INTEGRATION}`, getIntegrations: `ProviderVuex/${GET_INTEGRATIONS}` }),

        mountData() {

            if (this.integration.integrator === 'ozmap') {

                this.img = 'https://res.cloudinary.com/devoz/image/upload/v1617114535/LOGO_OZmap_2_y6zfoz.png'
                this.integrationLink = 'https://ajuda.ozmap.com.br/support/solutions/articles/44002157994-querointernet'
                this.link = 'https://ozmap.com.br/'

            } 

        },

        openIntegratorLink() {

            window.open(this.link, '_blank')

        },

        openHelpLink() {

            window.open(this.integrationLink, '_blank')

        },

        async syncClick() {

            try {

                await this.syncIntegration({ ids: [this.integration._id] }) 
                
                return this.showToast(this.$t('integrations.sync_integration'), this.$t('integration'), 'info')

            } catch (error) {

                return this.showToast(error.message, this.$t('integration'), 'error')
                
            }
        },

        async handleChangedOptions() {

            this.dialogOptions = false

            try {

                this.getIntegrations()
                
            } catch (error) {

                return this.showToast(error.message, this.$t('integration'), 'error')
                
            }
        }
        
    },

    created() {

       this.mountData()

    }
}

</script>

<style scoped>

.no-click {

    cursor: default;


}


</style>